import { IMenuItemModel } from "../index";
import Routes from "Routes";

const menu: IMenuItemModel = {
  name: "Imóveis Rurais",
  link: Routes.properties.replace(":category?", ""),
  submenu: [
    {
      category: "Chácaras",
      link: Routes.properties.replace(":category?", "chacaras"),
    },
    {
      category: "Fazendas",
      link: Routes.properties.replace(":category?", "fazendas"),
    },
    {
      category: "Frigoríficos",
      link: Routes.properties.replace(":category?", "frigorificos"),
    },
    {
      category: "Granjas",
      link: Routes.properties.replace(":category?", "granjas"),
    },
    {
      category: "Jazidas",
      link: Routes.properties.replace(":category?", "jazidas"),
    },
    {
      category: "Laticínios",
      link: Routes.properties.replace(":category?", "laticinios"),
    },
    {
      category: "Ranchos",
      link: Routes.properties.replace(":category?", "ranchos"),
    },
    {
      category: "Sítios",
      link: Routes.properties.replace(":category?", "sitios"),
    },
    {
      category: "Terrenos/Lotes",
      link: Routes.properties.replace(":category?", "terrenos-lotes"),
    },
    {
      category: "Usinas/Destilarias",
      link: Routes.properties.replace(":category?", "usinas-destilarias"),
    },
    {
      category: "Outros Imóveis Rurais",
      link: Routes.properties.replace(":category?", "outros-imoveis-rurais"),
    },
  ],
};

export default menu;
